<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper blank-page">
    <!-- Header -->
    <layout-header />
    <!-- /Header -->

    <div class="overflow-hidden bg-light bg-cover bg-no-repeat pb-md-5 pb-4 rounded-none position-relative w-100 features-img"
        :style="'padding-top: 120px;background-position:center;background-image: url('+require('@/assets/img/bg-hero.jpg')+');'">
        <div class="container px-4 py-3 mx-auto position-relative" style="z-index: 1">
          <h2 class="text-center text-white my-5 display-3 fw-bold">Politique de Confidentialité</h2>
        </div>
    </div>

    <!-- Page Content -->
    <div class="content" style="margin-top: 2rem;">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10 col-xl-9 pb-5">
            <div class="text-center mb-5 mt-4">
              <p class="lead text-muted">
                Chez <strong class="text-primary">6v6</strong>, nous nous engageons à protéger votre vie privée et vos données personnelles. 
                Cette politique de confidentialité vous informe sur la manière dont nous collectons, utilisons et protégeons vos informations.
              </p>
              <p class="text-muted small">
                <i class="material-icons-outlined align-middle me-1" style="font-size: 18px;">schedule</i>
                Dernière mise à jour : Février 2026
              </p>
            </div>
            <div class="card mb-4 rounded-xl shadow-sm">
              <div class="card-body">
                <h5 class="card-title text-primary mb-3">
                  <i class="material-icons-outlined align-middle me-2">info</i>
                  1. Introduction
                </h5>
                <p class="card-text text-muted">
                  La présente Politique de Confidentialité décrit la manière dont <strong>6v6</strong> collecte, utilise et protège vos données personnelles lors de l'utilisation de notre plateforme.
                </p>
              </div>
            </div>
            <div class="card mb-4 rounded-xl shadow-sm">
              <div class="card-body">
                <h5 class="card-title text-primary mb-3">
                  <i class="material-icons-outlined align-middle me-2">storage</i>
                  2. Collecte des Données
                </h5>
                <p class="card-text text-muted mb-2">Nous collectons les données suivantes :</p>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item">Nom et prénom</li>
                  <li class="list-group-item">Adresse e-mail</li>
                  <li class="list-group-item">Numéro de téléphone</li>
                  <li class="list-group-item">Informations de paiement</li>
                  <li class="list-group-item">Données de navigation (adresse IP, type de navigateur, pages consultées)</li>
                </ul>
              </div>
            </div>
            <div class="card mb-4 rounded-xl shadow-sm">
              <div class="card-body">
                <h5 class="card-title text-primary mb-3">
                  <i class="material-icons-outlined align-middle me-2">settings</i>
                  3. Utilisation des Données
                </h5>
                <p class="card-text text-muted mb-2">Vos données sont utilisées pour :</p>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item">Gérer vos réservations et transactions</li>
                  <li class="list-group-item">Vous envoyer des confirmations de réservation et des informations relatives à nos services</li>
                  <li class="list-group-item">Améliorer la qualité de nos services et personnaliser votre expérience utilisateur</li>
                  <li class="list-group-item">Respecter nos obligations légales et réglementaires</li>
                </ul>
              </div>
            </div>
            <div class="card mb-4 rounded-xl shadow-sm">
              <div class="card-body">
                <h5 class="card-title text-primary mb-3">
                  <i class="material-icons-outlined align-middle me-2">share</i>
                  4. Partage des Données
                </h5>
                <p class="card-text text-muted mb-2">Vos données peuvent être partagées avec :</p>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item">Nos partenaires propriétaires des terrains pour la gestion des réservations</li>
                  <li class="list-group-item">Nos prestataires de services (paiement, hébergement, etc.) dans le cadre de l'exécution de nos services</li>
                </ul>
              </div>
            </div>
            <div class="card mb-4 rounded-xl shadow-sm">
              <div class="card-body">
                <h5 class="card-title text-primary mb-3">
                  <i class="material-icons-outlined align-middle me-2">shield</i>
                  5. Sécurité des Données
                </h5>
                <p class="card-text text-muted">
                  Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, perte ou divulgation.
                </p>
              </div>
            </div>
            <div class="card mb-4 rounded-xl shadow-sm">
              <div class="card-body">
                <h5 class="card-title text-primary mb-3">
                  <i class="material-icons-outlined align-middle me-2">verified_user</i>
                  6. Vos Droits
                </h5>
                <p class="card-text text-muted mb-2">Conformément à la législation en vigueur, vous disposez des droits suivants :</p>
                <ul class="list-group list-group-flush mb-3">
                  <li class="list-group-item">Droit d'accès, de rectification et de suppression de vos données personnelles</li>
                  <li class="list-group-item">Droit à la portabilité de vos données</li>
                  <li class="list-group-item">Droit d'opposition au traitement de vos données</li>
                </ul>
                <div class="alert alert-info mb-0" role="alert">
                  <i class="material-icons-outlined align-middle me-2">email</i>
                  Pour exercer ces droits, vous pouvez nous contacter à l'adresse suivante : <strong>contact@6v6foot.com</strong>
                </div>
              </div>
            </div>
            <div class="card mb-4 rounded-xl shadow-sm">
              <div class="card-body">
                <h5 class="card-title text-primary mb-3">
                  <i class="material-icons-outlined align-middle me-2">cookie</i>
                  7. Cookies
                </h5>
                <p class="card-text text-muted">
                  La plateforme utilise des cookies pour améliorer votre expérience utilisateur. Vous pouvez gérer vos préférences en matière de cookies via les paramètres de votre navigateur.
                </p>
              </div>
            </div>
            <div class="card mb-4 rounded-xl shadow-sm">
              <div class="card-body">
                <h5 class="card-title text-primary mb-3">
                  <i class="material-icons-outlined align-middle me-2">update</i>
                  8. Modifications de la Politique de Confidentialité
                </h5>
                <p class="card-text text-muted">
                  <strong>6v6</strong> se réserve le droit de modifier cette Politique de Confidentialité. Toute modification sera publiée sur cette page avec la date de mise à jour.
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->

    <!-- Footer -->
    <layout-footer />
    <!-- /Footer -->
  </div>
</template>
<script>
export default {
  mounted() {
    // Content div min height set

    function resizeInnerDiv() {
      var height = $(window).height();
      var header_height = $(".header").height();
      var footer_height = $(".footer").height();
      var breadcrumb_height = $(".breadcrumb-bar").height();
      var setheight = height - breadcrumb_height - header_height;
      var trueheight = setheight - footer_height;
      $(".content").css("min-height", trueheight - 30);
    }

    if ($(".content").length > 0) {
      resizeInnerDiv();
    }

    $(window).resize(function () {
      if ($(".content").length > 0) {
        resizeInnerDiv();
      }
    });
  },
};
</script>
